import React, {useEffect, useState} from 'react';
import {Chart} from 'primereact/chart';

export default function SongTitleDistributionChart({playlist}) {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        const songData = getSongDistributionPlaylist(playlist);

        const data = {
            labels: songData["labels"],
            datasets: [
                {
                    type: 'bar',
                    label: 'Number of Plays',
                    backgroundColor: documentStyle.getPropertyValue('--primary-500'),
                    data: songData["counts"]
                }
            ]
        };
        const options = {
            indexAxis: 'y',
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    beginAtZero: true,
                    stacked: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };

        setChartData(data);
        setChartOptions(options);
    }, [playlist]);

    return (
        <div className="card">
            <Chart type="bar" data={chartData} options={chartOptions} />
        </div>
    )
}

export function getSongDistributionPlaylist(playlist) {
    let labels = [];
    let counts = [];
    for (let i = 0; i < playlist.length; i++) {
        let artistsong = playlist[i].nameconcat;
        let notfound = true;
        let j = 0;
        while (notfound && j < labels.length) {
            if (artistsong === labels[j]) {
                notfound = false;
                counts[j] = counts[j] + 1
            }
            j = j + 1;
        }
        if (notfound) {
            labels.push(artistsong);
            counts.push(1);
        }
    }

    return {"counts": counts, "labels": labels};
}